import React from "react";
import BottomNav from "@/components/BottomNav";
import FloatingActions from "@/components/FloatingActions";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen pb-24" style={{ background: "var(--bg-cream)" }}>
      <div className="mx-auto max-w-3xl px-4 py-4 sm:px-6 sm:py-6">
        {children}
      </div>
      <FloatingActions />
      <BottomNav />
    </div>
  );
}
